// @flow

import { t } from '@lingui/macro';

import { Color, DSTokenMap } from '@rover/kibble/styles';
import type { Untranslated } from '@rover/shared/js/types';

import { type Props } from './Alert.types';
import AlertSeverity from './AlertSeverity';

export { AlertSeverity };

export const AlertSeverityLabel: { [AlertSeverity]: Untranslated } = {
  [AlertSeverity.DANGER]: /* i18n: alert severity */ t`danger`,
  [AlertSeverity.WARNING]: /* i18n: alert severity */ t`warning`,
  [AlertSeverity.SUCCESS]: /* i18n: alert severity */ t`success`,
  [AlertSeverity.INFO]: /* i18n: alert severity */ t`info`,
};

const ALERT_SEVERITY_BACKGROUNDS: { [AlertSeverity]: string } = {
  [AlertSeverity.DANGER]: Color.RED_96,
  [AlertSeverity.WARNING]: Color.YELLOW_96,
  [AlertSeverity.SUCCESS]: Color.GREEN_96,
  [AlertSeverity.INFO]: Color.BLUE_96,
};

const ALERT_SEVERITY_BORDERS: { [AlertSeverity]: string } = {
  [AlertSeverity.DANGER]: DSTokenMap.BORDER_COLOR_ERROR,
  [AlertSeverity.WARNING]: Color.YELLOW_BASE,
  [AlertSeverity.SUCCESS]: Color.GREEN_BASE,
  [AlertSeverity.INFO]: Color.BLUE_BASE,
};

export const getBackgroundColorForSeverity = ({
  severity,
}: {
  severity: $PropertyType<Props, 'severity'>,
}) => {
  const severityBackground = ALERT_SEVERITY_BACKGROUNDS[severity];
  if (severityBackground) return severityBackground;
  return ALERT_SEVERITY_BACKGROUNDS[AlertSeverity.INFO];
};

export const getBorderColorForSeverity = ({
  severity,
}: {
  severity: $PropertyType<Props, 'severity'>,
}) => {
  const severityBorder = ALERT_SEVERITY_BORDERS[severity];
  if (severityBorder) return severityBorder;
  return ALERT_SEVERITY_BORDERS[AlertSeverity.INFO];
};

export const defaultProps = {
  severity: AlertSeverity.INFO,
  onDismiss: undefined,
};



// WEBPACK FOOTER //
// ../react-lib/src/components/notifications/Alert/Alert.common.js